var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgG = function SvgG(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h58v32H0zm58 0 18 15.5L58 32V0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.29 15.322v1.962h3.582c-.216 1.278-1.458 2.592-3.582 2.592-2.286 0-3.924-1.566-3.924-4.23 0-2.772 1.836-4.32 4.158-4.32 1.53 0 2.772.576 3.906 1.44l.864-2.196c-1.278-.864-2.79-1.53-4.77-1.53-3.762 0-6.696 2.61-6.696 6.624 0 3.852 2.61 6.534 6.084 6.534 2.034 0 3.42-.954 4.086-1.89v1.71h2.214v-6.696H17.29Z",
    fill: "#fff"
  })));
};
export default SvgG;